import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTenantAuth } from "../context/auth";

export function TenantLoginPage() {
  const nav = useNavigate();
  const { login } = useTenantAuth();
  const [tenantId, setTenantId] = useState("");
  const [email, setEmail] = useState("owner@bootstrap.local");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    try {
      setError("");
      await login(tenantId, email, password);
      nav("/app/dashboard");
    } catch (err) {
      setError(String(err));
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center px-3">
      <form className="panel p-6 w-full max-w-md grid gap-3" onSubmit={submit}>
        <h1 className="text-2xl font-semibold">Salon Manager Login</h1>
        <p className="text-sm text-slate-500">Use the Tenant ID shared from System Manager onboarding.</p>
        <input className="input" placeholder="Tenant ID" value={tenantId} onChange={(e) => setTenantId(e.target.value)} />
        <input className="input" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} />
        <input className="input" type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} />
        <button className="btn" type="submit">
          Login
        </button>
        {error ? <p className="text-red-600 text-sm">{error}</p> : null}
      </form>
    </div>
  );
}

